import * as React from 'react';

import * as problemQuestions from '../styles/problemQuestions.module.scss';

export const ProblemQuestions = () => {
  return (
    <section className={problemQuestions.problemQuestions}>
      <div className={'container'}>
        <div className={`row ${problemQuestions.problemQuestions__wrapper}`}>
          <ul className={`col-lg-6 ${problemQuestions.problemQuestions__list}`}>
            <li
              className={`${problemQuestions.problemQuestions__element} ${problemQuestions.problemQuestions__elementOne} ${problemQuestions.problemQuestions__text}`}
            >
              Устали каждый день разбираться с ребёнком в английской грамматике?
            </li>
            <li
              className={`${problemQuestions.problemQuestions__element} ${problemQuestions.problemQuestions__elementTwo} ${problemQuestions.problemQuestions__text}`}
            >
              Ребёнок не понимает, как строить элементарные предложения на английском языке?
            </li>
            <li
              className={`${problemQuestions.problemQuestions__element} ${problemQuestions.problemQuestions__elementThree} ${problemQuestions.problemQuestions__text}`}
            >
              Допускает ошибки в тестах и самостоятельных?
            </li>
          </ul>
          <div className={`col-lg-6 ${problemQuestions.problemQuestions__image}`}></div>
        </div>
      </div>
    </section>
  );
};
